import React from 'react';
import { getAdminApiUrl } from '@adsk/acs-sc-web-platform-api';
import { TrashCanIcon, SendArrowIcon } from '@adsk/alloy-react-icon';
import { getConstructionApiUrl } from '@adsk/acs-admin-ui-components-helpers';

export const getOptionsMenuItems = (status, removeLabel, onRemove, resendLabel, onResend) => [
  {
    key: 'actions',
    title: '',
    showSelection: false,
    itemOptions: [
      {
        key: 'remove',
        label: removeLabel,
        onClick: onRemove,
        renderIcon: () => <TrashCanIcon style={{ marginRight: '8px' }} />,
      },
      ...(status === 'pending'
        ? [
            {
              key: 'resend',
              label: resendLabel,
              onClick: onResend,
              renderIcon: () => (
                <SendArrowIcon style={{ marginRight: '8px' }} />
              ),
            },
          ]
        : []),
    ],
  },
];

export const buildResendInvitationRequest = (projectId, userId) => [
  `${getAdminApiUrl()}/v1/projects/${projectId}/users:resend-invitations`,
  {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ userIds: [userId] }),
  },
];

export const buildRemoveMemberRequest = (
  projectId,
  userId,
  useConstructionApi
) => {
  const url = useConstructionApi ? getConstructionApiUrl() : getAdminApiUrl();

  return [
    `${url}/v1/projects/${projectId}/users/${userId}`,
    {
      method: 'DELETE',
    },
  ];
};
